import React, { memo, useContext } from 'react';
import { useMemoizedFn } from 'ahooks';
import classnames from 'classnames';
import { Segment } from 'tea-component';
import { SegmentOption } from 'tea-component/lib/segment/SegmentOption';
import Development from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Projects/Details/components/Development';
import Live from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Projects/Details/components/Live';
import { context as Context } from '@gp/components/Context';
import { getLocationIsValid } from '@gp/utils/common';
import Filter from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Projects/Details/components/Live/components/Filter';
import usePageLog from '@gp/hooks/usePageLog';
import useLive from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Projects/Details/components/Live/hooks/useLive';
import './index.scss';

type ProjectsDetailsPropsType = IBaseProps;

const DEFAULT_PROPS: ProjectsDetailsPropsType = {};

const PROJECT_DETAILS_PAGES: SegmentOption[] = [
  { text: 'Live', value: 'live' },
  { text: 'Development', value: 'development' },
];

function ProjectsDetails(props: ProjectsDetailsPropsType) {
  const { style, className, ...remains } = props;

  const filterObj: any = getLocationIsValid('/Studio/PortfolioOverview');
  const filterPage = filterObj?.segment;
  const initialPage = PROJECT_DETAILS_PAGES?.map((item) => item?.value)?.includes(filterPage)
    ? filterPage
    : PROJECT_DETAILS_PAGES?.[0]?.value;

  const { studioId, studioName } = useContext<StudioOverallDetailContextTypes>(Context) || {};

  // const [page, setPage] = useState(initialPage);

  const {
    page,
    setPage,
    isLoading,
    projectFilterLoading,
    projects,
    sources,
    formModel,
    selectedProjects,
    handleFilterChange,
  } = useLive(studioId, initialPage);

  const handlePageChange = useMemoizedFn((value: string) => {
    if (value === page) return;
    setPage(value);
  });

  usePageLog({
    pageId: 'STUDIO_OVERALL_DETAILS_PROJECTS_LIVE',
    uidType: 'studio_id',
    uid: studioId || '',
    extInfo: studioName,
  });

  return (
    <>
      <div
        style={style}
        className={classnames('dbg-studio-overall-details-projects font14', className)}
      >
        <div className="dbg-studio-overall-details-flex">
          <Segment
            className="gp-common-segment dbg-studio-overall-details-projects-segment segment-light"
            value={page}
            options={PROJECT_DETAILS_PAGES}
            onChange={handlePageChange}
          />
          {page === PROJECT_DETAILS_PAGES?.[0]?.value && (
            <Filter
              projects={projects}
              sources={sources}
              value={formModel}
              onChange={handleFilterChange}
              projectFilterLoading={projectFilterLoading}
            />
          )}
        </div>
        <div className="dbg-studio-overall-details-projects-page-content">
          {page === PROJECT_DETAILS_PAGES?.[0]?.value && (
            <Live
              studioId={studioId}
              studioName={studioName}
              isLoading={isLoading}
              projectFilterLoading={projectFilterLoading}
              projects={projects}
              sources={sources}
              formModel={formModel}
              selectedProjects={selectedProjects}
            />
          )}
          {page === PROJECT_DETAILS_PAGES?.[1]?.value && (
            <Development studioId={studioId} studioName={studioName} />
          )}
        </div>
      </div>
    </>
  );
}

ProjectsDetails.defaultProps = DEFAULT_PROPS;

export default memo(ProjectsDetails);
